import { render, staticRenderFns } from "./InputBlock.vue?vue&type=template&id=7e56242d&scoped=true&"
import script from "./InputBlock.vue?vue&type=script&lang=js&"
export * from "./InputBlock.vue?vue&type=script&lang=js&"
import style0 from "./InputBlock.vue?vue&type=style&index=0&id=7e56242d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e56242d",
  null
  
)

export default component.exports